export enum WARNING_MESSAGE {
  UNMUTE_LOCAL_MIC_FAIL_MUTE_ALL = '已被全员静音，无法打开麦克风',
  UNMUTE_LOCAL_MIC_FAIL_MUTE_BY_MASTER = '已被主持人静音，无法打开麦克风',
  UNMUTE_LOCAL_MIC_FAIL_AUDIENCE = '申请发言房间，请先举手申请上麦',
  UNMUTE_LOCAL_CAMERA_FAIL_MUTE_ALL = '已被全员静画，无法打开视频',
  UNMUTE_LOCAL_CAMERA_FAIL_MUTE_BY_MASTER = '已被主持人静画，无法打开视频',
  UNMUTE_LOCAL_CAMERA_FAIL_AUDIENCE = '申请发言房间，请先举手申请上麦',
};

export enum MESSAGE_DURATION {
  NORMAL = 3000,
  LONG = 5000
};
